'use client'

import { FaceFrownIcon } from '@heroicons/react/24/outline'
import { useComponentTranslation } from '@tebuto/functions/translation.components'
import Heading from '@tebuto/typography/Heading'
import MediumText from '@tebuto/typography/MediumText'
import { WidgetButton } from '../WidgetButton'

interface BookingFailureProps {
    backToCalendar: () => void
}

export default function BookingFailure({ backToCalendar }: BookingFailureProps) {
    const { t } = useComponentTranslation()
    return (
        <div className="my-auto px-6 md:px-16 lg:px-32">
            <div className="grid gap-16">
                <div className="flex gap-10 my-10 items-center border-4 border-red-600 p-10 pb-8 rounded-lg bg-red-50">
                    <img src="/assets/favicon/favicon.svg" className="h-20 w-20" alt="check" />
                    <FaceFrownIcon className="h-20 w-20 text-red-600" />
                    <div className="flex flex-col">
                        <Heading className="text-red-600 font-semibold" level={3}>
                            {t('widgets.booking.failure.title')}
                        </Heading>
                        <MediumText className="widget-text-gray-500">
                            {t('widgets.booking.failure.message')}
                            <a href={`mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL}`}>
                                {t('widgets.booking.failure.contactUs')}
                            </a>
                            .
                        </MediumText>
                    </div>
                </div>
                <WidgetButton className="mx-auto w-64" onClick={backToCalendar}>
                    Zurück zum Kalender
                </WidgetButton>
            </div>
        </div>
    )
}
